module.exports = __webpack_public_path__ + "static/media/ice12.44d781c7.webp";